<template>
  <div class="animated fadeIn">
    <b-card border-variant="primary">
      <template slot="header">
        <i class='fa fa-align-justify'></i> WMDS
      </template>

      <b-row v-if="!is_main">
        <b-col sm="6">
          <b-pagination size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" />
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || 'search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='name';so.skt='name'">name</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='fqdn';so.skt='host'">host</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <!-- <b-btn variant="outline-secondary"><i class="fa fa-search-plus"></i></b-btn> -->
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime}}</template>
        <template slot="action" slot-scope="row">{{codes.agent_forgery[row.item.action] || "Changed"}}</template>
        <template slot="target" slot-scope="row">{{row.item.target}}</template>
        <!-- <template slot="hash" slot-scope="row">
          <b-form-select size="sm" v-model="row.item.hash_selected">
            <option :value="{ key : 0, value : row.item.hash[0]}">static</option>
            <option :value="{ key : 1, value : row.item.hash[1]}">level 1</option>
            <option :value="{ key : 2, value : row.item.hash[2]}">level 2</option>
            <option :value="{ key : 3, value : row.item.hash[3]}">level 3</option>
            <option :value="{ key : 4, value : row.item.hash[4]}">level 4</option>
            <option :value="{ key : 5, value : row.item.hash[5]}">level 5</option>
          </b-form-select>
        </template>
        <template slot="depth" slot-scope="row">
          <b-form-input size="sm" v-model="row.item.hash_selected.key">{{row.item.hash_selected.key}}</b-form-input>
        </template>
        <template slot="is_apply" slot-scope="row">{{row.item.is_apply ? 'Confirm' : 'unidentified'}}</template>
        <template slot="func" slot-scope="row">
          <b-btn @click="save(row.item)" size="sm" variant="outline-success">Pass</b-btn>
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">More</b-btn>
        </template> -->
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next" />
        </b-col>
      </b-row>
    </b-card>
    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
import { Api } from '@/service';
import codes from '@/codes'

const default_opt = () => ({
  perPage: 10,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}
});

export default {
  props: ['is_main', 'limit'],
  data : () => {
    return {
      codes,
      so : default_opt(),
      selected : '',
      limti : 10
    }
  },
  computed: {
    rowCount: function() { return this.so.totalRows || 0; },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return [
        { key: 'id', label: '#', sortable: false, thStyle: 'width: 5%' },
        // { key: 'type', label: 'Type', sortable: false, thStyle: 'width: 8%' },
        { key: 'created_at', label: 'Time', sortable: false, thStyle: 'width: 15%' },
        { key: 'action', label: 'Action', sortable: false, thStyle: 'width: 10%' },
        { key: 'target', label: 'Target', sortable: false },
      ];
    },
  },
  methods: {
    save(item) {
      // let snapshot = [[item.target, item.hash_selected.key, item.hash_selected.value]]
      // Api.Manager_Call({target: 'integrity.detect', cmd : 'update', body : { id : item.id, snapshot : snapshot, site_id : item.site_id, group_id : item.group_id, is_apply : true }})
      // Api.Manager_Call({target: 'integrity', cmd : 'update', body : { id : item.id, snapshot : snapshot, site_id : item.site_id, group_id : item.group_id, is_apply : true }})
      // this.$toastr.s('Application completed');

    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { console.log('WMDS', 'refresh'); this.$refs._list.refresh(); },
    getItems(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let so = {
        target : 'integrity.detect', cmd : 'list',
        body : { sort : [{ name : "id", op : "desc"}], or : [], and : [{ name : "type", value : "wmds", op : "="}], columns : ["id", "created_at", "action", "target"] },
        offset : (this.so.currentPage-1 || 0) * this.limit, limit: this.limit, // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and = [{ name : 'is_del', value : false, op : '='}, { name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' } ] }
      return Api.Manager(so).then(rs => { this.so.totalRows = rs.total; this.model = rs.body; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText) );
    },
    detail(item) { console.log(item); this.$router.push(`domainresult/${item.id}`); },
    hideList: function(e) {
      this.show = !e; console.log('site.vue', 'got event (list show/hide)', !e ? 'show' : 'hide')
  	}
  },
  created() { console.log('WMDS', 'integrity.vue', 'created'); },
  destroyed() { console.log('WMDS', 'integrity.vue', 'destroyed'); },
  mounted() { console.log('WMDS', 'integrity.vue', 'mounted'); },
}
</script>
